import { render, staticRenderFns } from "./Customizer.vue?vue&type=template&id=aef6f938"
import script from "./Customizer.vue?vue&type=script&lang=js"
export * from "./Customizer.vue?vue&type=script&lang=js"
import style0 from "./Customizer.vue?vue&type=style&index=0&id=aef6f938&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports